import { useEffect, useState, type ReactNode } from "react";
import Onboarding from "../routes/Onboarding";
import { loadOnboardingStatus, skipOnboarding } from "../lib/onboarding";
import { AppShellSkeleton } from "./Skeletons";

interface Props {
  children: ReactNode;
}

/**
 * Sits inside AuthGate. If the signed-in user hasn't completed the onboarding
 * wizard yet, render Onboarding instead of the children.
 */
export default function OnboardingGate({ children }: Props) {
  const [state, setState] = useState<"loading" | "needs" | "done">("loading");

  useEffect(() => {
    loadOnboardingStatus()
      .then((s) => setState(s.onboarded ? "done" : "needs"))
      .catch(() => setState("done"));
  }, []);

  if (state === "loading") {
    return <AppShellSkeleton />;
  }
  if (state === "needs") {
    return (
      <Onboarding
        onComplete={() => setState("done")}
        onSkip={async () => {
          try {
            await skipOnboarding();
          } finally {
            setState("done");
          }
        }}
      />
    );
  }
  return <>{children}</>;
}
